<template>
  <profile-view v-if="selection" title="Отбор в тренеры" :subtitle="false">
    <template v-if="selection.exitTests.length">
      <profile-view-header>Пройдите итоговые тесты:</profile-view-header>
      <online-row-test v-for="test in selection.exitTests" :key="test.id" :id="'test-result-' + test.id" :result="{
        status: 'active',
        description: test.test.description,
        title: test.test.title,
        data: test.test
      }" />
    </template>
    <template v-if="selection.matrices.length">
      <profile-view-header>Заполните матрицы самооценки:</profile-view-header>
      <selection-enter v-for="enter in selection.matrices" :enter="enter" :key="enter.id" description="Перейти к матрице"/>
    </template>
    <template v-if="selection.enters.length">
      <profile-view-header>Входная анкета:</profile-view-header>
      <selection-enter v-for="enter in selection.enters" :enter="enter" :key="enter.id" description="Перейти к анкете"/>
    </template>
  </profile-view>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProfileView from "@/components/profile/ProfileView.vue";
import ProfileViewHeader from "@/components/profile/ProfileViewHeader.vue";
import SelectionEnter from "@/components/profile/selection/SelectionEnter.vue";
import OnlineRowTest from "@/components/profile/online/OnlineRowTest.vue";

export default {
  name: "Selection",
  components: {OnlineRowTest, ProfileViewHeader, SelectionEnter, ProfileView},
  async mounted() {
    await this.getSelection()
  },
  computed: {
    ...mapGetters(['selection']),
    subtitle() {
      return this.selection.enters.length ? 'Входная анкета' : ''
    }
  },
  methods: {
    ...mapActions(['getSelection'])
  }
}
</script>

<style scoped>

</style>